import Vue from 'vue'
import Router from 'vue-router'
import Start from '@/pages/Start'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Start',
            component: Start
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js